export default __webpack_public_path__ + "static/media/prayers-of-wars.b54028d1.jpg";